'use client';

import { faClose, faSearch } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, InputField } from '@pickleballinc/react-ui';
import { useRouter } from 'next/navigation';

interface SearchFieldProps {
	placeholder?: string;
	maxLength?: number;
	size?: number;
	className?: string;
	setSearchTerm: (value: string) => void;
	searchTerm: string;
}

export const SearchField = ({
	placeholder = 'Search...',
	maxLength = 100,
	size = 40,
	className = 'h-10 overflow-x-auto overflow-y-hidden',
	searchTerm,
	setSearchTerm
}: SearchFieldProps) => {
	const router = useRouter();

	const updateSearchParams = (value: string) => {
		const params = new URLSearchParams(window.location.search);
		if (value.trim()) {
			params.set('query', value);
		} else {
			params.delete('query');
		}
		router.push(`?${params.toString()}`);
	};

	const handleSearch = () => {
		updateSearchParams(searchTerm);
	};

	return (
		<div className="hidden flex items-center gap-2">
			<InputField
				focusColor="orange"
				value={searchTerm}
				PrefixIcon={() => <FontAwesomeIcon icon={faSearch} size="sm" className="text-gray-500" />}
				SuffixIcon={() =>
					searchTerm ? (
						<FontAwesomeIcon
							icon={faClose}
							size="sm"
							className="cursor-pointer text-gray-500 hover:text-gray-700"
							onClick={(e) => {
								e.stopPropagation();
								setSearchTerm('');
								updateSearchParams('');
							}}
						/>
					) : (
						<div className="w-2.5" />
					)
				}
				placeholder={placeholder}
				onChange={(e) => {
					setSearchTerm(e.target.value);
				}}
				onKeyDown={(e) => {
					if (e.key === 'Enter') {
						handleSearch();
					}
				}}
				maxLength={maxLength}
				size={size}
				className={className}
			/>
			<Button variant="secondary" size="xs" onClick={handleSearch}>
				Search
			</Button>
		</div>
	);
};
